import './Loader.scss'
import Loader from "./Loader";

export default Loader